// v19.7 — Training Ground <-> DAW live-sync bus.
//
// The DAW's Sampler dropdown pulls its options from a fetched snapshot of
// every drum / bass / melody kit. Before this bus, once the Sampler had
// fetched that snapshot on mount, any subsequent Training Ground edit
// (add sample, delete sample, rename label, delete kit, set default) was
// invisible to the DAW until a full page reload — producers saw ghost
// entries for deleted sounds and stale labels for renamed ones.
//
// This module broadcasts a "kits-changed" pulse whenever the Training
// Ground writes to the database. The DAW's Sampler subscribes to the
// pulse and immediately refreshes its library, re-syncs the on-track
// display names, and drops any track that was pointing at a now-deleted
// sample.
//
// Cross-tab safe: BroadcastChannel handles the (admin editing in tab A
// while the DAW is open in tab B) case; same-tab window events cover the
// (Training Ground and DAW both in tab A) case.
const CHANNEL_NAME = "crow-kits";
const EVENT_NAME = "crow:kits-changed";

let _bc = null;
try {
  if (typeof BroadcastChannel !== "undefined") {
    _bc = new BroadcastChannel(CHANNEL_NAME);
  }
} catch { /* older browsers / SSR */ }

// Notify every listener (same tab + other tabs) that the kits DB changed.
// `detail` is optional metadata (e.g. { source: "drum-kits", op: "delete-sample" }).
export function notifyKitsChanged(detail = {}) {
  const payload = { ts: Date.now(), ...detail };
  try {
    window.dispatchEvent(new CustomEvent(EVENT_NAME, { detail: payload }));
  } catch { /* noop */ }
  try {
    _bc?.postMessage(payload);
  } catch { /* noop */ }
}

// Subscribe. Returns unsubscribe fn. Listener receives the detail object.
export function onKitsChanged(listener) {
  const winHandler = (e) => { try { listener(e?.detail || {}); } catch { /* noop */ } };
  const bcHandler = (e) => { try { listener(e?.data || {}); } catch { /* noop */ } };
  try { window.addEventListener(EVENT_NAME, winHandler); } catch { /* noop */ }
  try { _bc?.addEventListener("message", bcHandler); } catch { /* noop */ }
  return () => {
    try { window.removeEventListener(EVENT_NAME, winHandler); } catch { /* noop */ }
    try { _bc?.removeEventListener("message", bcHandler); } catch { /* noop */ }
  };
}
